import * as React from 'react';
import { useSelector } from 'react-redux';
import { setCookie } from '@cian/utils/lib/browser/cookie';

import { selectHhQueryParams, selectHhIsHidden } from '../selectors/hh';
import { IHhQueryParams } from '../types/hh';
import { getCookie } from '../utils/cookie';

const COOKIE_KEY = 'hh_lead_params';

export const useHhQueryParamsFromCookie = () => {
  const [cookieValue, setCookieValue] = React.useState<IHhQueryParams | null>(null);
  const hhQueryParams = useSelector(selectHhQueryParams);
  const isHidden = useSelector(selectHhIsHidden);

  const updateCookieValue = (queryParams: IHhQueryParams | null) => {
    if (queryParams !== null) {
      const newCookieValue = JSON.stringify(queryParams);
      setCookie(COOKIE_KEY, newCookieValue);
      setCookieValue(queryParams);
    }
  };

  React.useEffect(() => {
    if (!isHidden) {
      setCookieValue(null);

      return;
    }

    const cookie = getCookie(COOKIE_KEY);

    if (cookie) {
      const decodedValue = decodeURIComponent(cookie);

      if (hhQueryParams !== null && JSON.stringify(hhQueryParams) !== decodedValue) {
        updateCookieValue(hhQueryParams);
      } else {
        setCookieValue(JSON.parse(decodedValue));
      }
    } else {
      updateCookieValue(hhQueryParams);
    }
  }, [hhQueryParams, isHidden]);

  return cookieValue;
};
